import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-[320px] md:min-h-[340px] flex items-end justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.34), rgba(255,255,255,0.34)), url('/images/topstockpickhero.webp')",
          filter: 'grayscale(100%)',
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            'repeating-linear-gradient(115deg, rgba(255,255,255,0.20) 0px, rgba(255,255,255,0.20) 2px, rgba(255,255,255,0) 2px, rgba(255,255,255,0) 10px)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/25" />

      <div className="relative z-10 w-full max-w-[1200px] mx-auto lg:px-6 pb-0">
        <div className="relative translate-y-6 md:translate-y-8 flex flex-col items-center lg:block">
          <div
            className="bg-[#162948] lg:rounded-[16px] rounded-none w-full max-w-full lg:max-w-[min(83%,998px)] mx-auto text-center shadow-[0_10px_30px_rgba(0,0,0,0.28)] flex flex-col justify-center"
            style={{
              padding: 'clamp(1.25rem, 3%, 2rem) clamp(1.25rem, 4%, 2.5rem)',
            }}
          >
            <span className="text-[#D4A129] font-[400] text-[25px] md:text-[33px]">
            Unlock Massive Gains in Junior Mining:
            </span>
            <p className="mt-1 lg:mb-5 mb-2 text-[#FFFFFF] text-[18px] sm:text-[22px] md:text-[26px] lg:text-[28px] font-[600] leading-tight tracking-[0.01em]">
                Real Wins from The Wealthy Miner
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
